import { useNavigate } from "react-router-dom";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { contactUrls } from "../../URL/ApplicationUrls";
import { Contact } from "../Contact";
import { addSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useAddContact = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (contact: Contact) => {
      return axios.post<number>(contactUrls.addContact.apiUrl, { ...contact });
    },
    onSuccess: async (response: AxiosResponse) => {
      navigate(contactUrls.contactWithId(response.data).uiPath);
      toast.success(addSuccessMessage(response.data, "Contact"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
